import React, {Component} from 'react'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'

import TSelectForm from "../../../common/TSelectForm"
import * as SaveStatus from '../../../../constants/SaveStatus'
import {jsonResponseHandler} from "../../../../utils/FetchHelper"
import {changeSloganAddress} from '../../../../actions/setting/blog'
import TSubmitButtonForm from "../../../common/TSubmitButtonForm";
import {addPrefix} from "../../../../utils/UriUtil";

@connect(state => ({
    address: state.setting.blog.address
}), dispatch => ({
    handleChangeSloganAddress(address) {
        dispatch(changeSloganAddress(address))
    },
    dispatch
}))
class BlogAddressForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = Object.assign({
            useSecureProtocol: props.address.useSecureProtocol,
            useSlogan : props.address.useSlogan,
            saveStatus: SaveStatus.READY,
        }, props.address)

    }

    @autobind
    handleChangeUseSlogan(item) {
        this.setState({
            useSlogan: item.value
        })
    }

    @autobind
    handleSubmit(e) {
        e.preventDefault()

        const {useSlogan, saveStatus } = this.state
        const {handleChangeSloganAddress, dispatch} = this.props

        if (saveStatus === SaveStatus.DOING) {
            return
        }

        const address = {
            useSlogan
        }

        this.setState({
            saveStatus: SaveStatus.DOING
        })
        fetch(addPrefix("/manage/setting/blog/address.json"), {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(address)
        })
            .then(jsonResponseHandler(dispatch))
            .then(() => {
                this.setState({
                    saveStatus: SaveStatus.DONE
                })
                handleChangeSloganAddress(useSlogan)
            })
            .catch(e => {
                console.error(e)
                this.setState({
                    saveStatus: saveStatus
                })
            })
    }

    renderUrlPreview() {
        const { primaryDomain, secondaryDomain, useSecondaryDomain, useSecureProtocol, certStatus } = this.props.address

        const { useSlogan } = this.state

        let domain = useSecondaryDomain ? secondaryDomain : primaryDomain
        let path = useSlogan? 'entry/티스토리-환영합니다.' : '123'
        let protocol = 'http'

        if (domain === primaryDomain && useSecureProtocol) {
            protocol = 'https'
        } else {
            if (certStatus === 'SUCCESS') {
                protocol = 'https'
            }
        }

        return (
            <span className="txt_tf">{protocol}://{domain}/<em>{path}</em></span>
        )
    }

    isChangedAndValid() {
      const { useSlogan } = this.state
      const { address } = this.props

      return useSlogan !== address.useSlogan
    }

    render() {
        const { primaryDomain, useSecureProtocol } = this.props.address

        const { useSlogan, saveStatus} = this.state

        let needSave = this.isChangedAndValid()
        let status = saveStatus
        if (saveStatus !== SaveStatus.DOING && needSave) {
            status = SaveStatus.CAN_SUBMIT
        }

        const tistoryProtocol = useSecureProtocol ? 'https' : 'http'

        return (
          <form className="wrap_set" onSubmit={this.handleSubmit}>
            <fieldset className="fld_address1">
              <legend className="screen_out">기본도메인</legend>
              <div className="item_set">
                <span className="txt_item">기본 도메인</span> <em className="txt_emph">{tistoryProtocol}://{primaryDomain}</em>
                <a href="https://notice.tistory.com/2470" className="link_domain" target="_blank">
                  보안접속 중<span className="ico_blog ico_question"/>
                </a>
              </div>
            </fieldset>
            <fieldset className="fld_address1">
              <legend className="screen_out">사이트맵주소</legend>
              <div className="item_set">
                <span className="txt_item">사이트맵 주소</span> <em className="txt_emph">{tistoryProtocol}://{primaryDomain}/sitemap.xml</em>
                <a href="https://notice.tistory.com/2537" className="link_domain" target="_blank">
                  자동 생성 안내<span className="ico_blog ico_question"/>
                </a>
              </div>
            </fieldset>
            <fieldset className="fld_address3">
              <legend className="screen_out">포스트 주소 설정</legend>
              <div className="item_set">
                포스트 주소를
                <TSelectForm className="opt_set opt_address2" items={[
                            {label: '숫자', value: false},
                            {label: '문자', value: true}
                        ]} selected={useSlogan} onSelect={this.handleChangeUseSlogan}/>

                        로 설정합니다.
                {this.renderUrlPreview()}
              </div>
            </fieldset>
            <fieldset>
                    <legend className="screen_out">저장 버튼</legend>
                    <TSubmitButtonForm type="submit" status={status}/>
                </fieldset>
          </form>
        )
    }
}

export default BlogAddressForm
